import { render, staticRenderFns } from "./scrollable-modal.vue?vue&type=template&id=54db3b97&scoped=true&"
import script from "./scrollable-modal.vue?vue&type=script&lang=js&"
export * from "./scrollable-modal.vue?vue&type=script&lang=js&"
import style0 from "./scrollable-modal.vue?vue&type=style&index=0&id=54db3b97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54db3b97",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54db3b97')) {
      api.createRecord('54db3b97', component.options)
    } else {
      api.reload('54db3b97', component.options)
    }
    module.hot.accept("./scrollable-modal.vue?vue&type=template&id=54db3b97&scoped=true&", function () {
      api.rerender('54db3b97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scrollable-modal.vue"
export default component.exports